<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <div class="card card-custom">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">Çağdaş Mert Grubu</span>
            <span class="text-muted mt-1 font-weight-bold font-size-sm">{{$t('menu.definitions')}}</span>
          </h3>
          <div class="card-toolbar">
            <b-form-group label="" class="fa-pull-right">
              <b-button-group size="sm">
                <b-button v-b-modal.edit @click="ClearForm"><i class="fas fa-plus"></i> {{$t('tests.add')}}</b-button>
                <b-button v-b-modal.multiple_upload><i class="far fa-clone"></i> {{$t('tests.add_multiple')}}</b-button>
              </b-button-group>
            </b-form-group>

            <b-modal id="multiple_upload" :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" :title="$t('tests.add_multiple')">
              <b-form-group id="input-group-2" :label="$t('general.file_upload')" label-for="input-2">
                <b-form-file browse-text="Dosya Seç" :placeholder="$t('general.file_upload_placeholder')" id="file-default"></b-form-file>
              </b-form-group>
            </b-modal>

            <b-modal id="add_group" :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" :title="$t('tests.add_group')">
              <b-form-group id="input-group-2" :label="$t('tests.group_name')" label-for="input-2">
                <b-form-input
                    id="input-2"
                    required
                    :placeholder="$t('tests.group_name')"
                ></b-form-input>
              </b-form-group>
            </b-modal>
          </div>
        </div>
        <div class="card-body pt-10">
          <div class="row">
            <div class="col-xl-12">
              <b-button class="mb-3" @click="SendConfirm" size="sm"><i class="fas fa-paper-plane"></i> Seçilenlere Gönder</b-button>
              <data-table
                  :items="items"
                  :fields="report.fields"
                  :paginate="report.paginate"
                  page.sync="3"
                  perPage.sync="10"
              >
              </data-table>
              <b-modal size="lg" id="edit" :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" :title="$t('general.edit')">
                <div class="row">
                  <div class="col-xl-6">
                    <b-form-group id="input-group-2" :label="$t('tests.firstname')" label-for="input-2">
                      <b-form-input
                          id="input-2"
                          required
                          v-model="form.firstname"
                          :placeholder="$t('tests.firstname')"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-xl-6">
                    <b-form-group id="input-group-2" :label="$t('tests.lastname')" label-for="input-2">
                      <b-form-input
                          id="input-2"
                          required
                          v-model="form.lastname"
                          :placeholder="$t('tests.lastname')"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-xl-6">
                    <b-form-group id="input-group-2" :label="$t('general.email')" label-for="input-2">
                      <b-form-input
                          id="input-2"
                          required
                          v-model="form.email"
                          :placeholder="$t('general.email')"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-xl-6">
                    <b-form-group id="input-group-2" :label="$t('general.phone')" label-for="input-2">
                      <b-form-input
                          id="input-2"
                          required
                          v-model="form.phone"
                          :placeholder="$t('general.phone')"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </b-modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";

export default {
  name: "InternalTestsList",
  components: { DataTable, DashboardBox },
  methods: {
    SendConfirm(){
      Swal.fire({
        title: "",
        text: "Grupta seçili listeye gönderim sağlanacak. Onaylıyor musunuz?",
        icon: "question",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText : "Evet",
        showCancelButton: true,
        cancelButtonText: 'Hayır',
        cancelButtonClass: "btn btn-danger"
      });
    },
    ClearForm(){
      this.form = {
        firstname: '',
        lastname : '',
        email : '',
        phone : ''
      };
    },

  },
  data() {
    return {
      form : {
        firstname : 'Çağdaş',
        lastname : 'Mert',
        email : 'cagdas.mert@dorinsight.com',
        phone : '5309617970'
      },
      items : [
        {'firstname' : 'Çağdaş', 'lastname' : 'Mert', 'email' : 'cagdas.mert@dorinsight.com', 'phone' : '5309617970', 'status' : 'Aktif' },
        {'firstname' : 'Çağdaş', 'lastname' : 'Mert', 'email' : 'cagdas.mert@dorinsight.com', 'phone' : '5309617970', 'status' : 'Aktif' },
        {'firstname' : 'Çağdaş', 'lastname' : 'Mert', 'email' : 'cagdas.mert@dorinsight.com', 'phone' : '5309617970', 'status' : 'Aktif' },
        {'firstname' : 'Çağdaş', 'lastname' : 'Mert', 'email' : 'cagdas.mert@dorinsight.com', 'phone' : '5309617970', 'status' : 'Aktif' },
        {'firstname' : 'Çağdaş', 'lastname' : 'Mert', 'email' : 'cagdas.mert@dorinsight.com', 'phone' : '5309617970', 'status' : 'Aktif' },
      ],
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'checkbox', label: 'Seç', sortable: false},
          {key: 'firstname', label: 'Ad', sortable: false},
          {key: 'lastname', label: 'Soyad', sortable: true},
          {key: 'email', label: 'Email', sortable: true},
          {key: 'phone', label: 'Telefon', sortable: true},
          {key: 'status', label: 'Durum', sortable: true},
          {key: 'actions', label: 'İşlem', sortable: false},

        ],

      },
      selected : null,
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('menu.definitions'), route: "alert" },
      { title: 'Çağdaş Mert' }
    ]);
  },

}
</script>

<style scoped>

</style>
